import { getToken } from "@/utils";
import cart from "@/services/cart";

const initialState = () => ({
  cart: [],

  // cart quantity
  cartQuantity: 0,

  // 1 - Loading, 2 - Successful, 3 - unsuccesful, 4 - uncaught error
  sendLocalCartItemsStatus: 0,
  sendLocalCartItemsMessage: null,

  cartItemsStatus: 0,
  cartItemsMessage: null,

  addCartItemStatus: 0,
  addCartItemMessage: null,

  removeItemStatus: 0,
  removeItemMessage: null,

  removeAllItemsStatus: 0,
  removeAllItemsMessage: null,
})

const state = initialState();

const getters = {
  sendLocalCartItemsStatus: state => state.sendLocalCartItemsStatus,
  sendLocalCartItemsMessage: state => state.sendLocalCartItemsMessage,

  cartItemsStatus: state => state.cartItemsStatus,
  cartItemsMessage: state => state.cartItemsMessage,

  addCartItemStatus: state => state.addCartItemStatus,
  addCartItemMessage: state => state.addCartItemMessage,

  removeItemStatus: state => state.removeItemStatus,
  removeItemMessage: state => state.removeItemMessage,

  removeAllItemsStatus: state => state.removeAllItemsStatus,
  removeAllItemsMessage: state => state.removeAllItemsMessage,

  cart: state => state.cart ? state.cart : [],
  cartQuantity: state => state.cartQuantity,
}

const actions = {
  // TODO: remind backend developer to implement batch update functionality
  sendLocalCartItems: async ({ commit, state }) => {
    try {
      commit("sendLocalCartItemsRequest");

      let cartData = [];
      state.cart.forEach(cartItem => {
        cartData.push({ quantity: cartItem.quantity, product_id: cartItem.product.id })
      });

      const response = await cart.sendLocalItems({ cartData });
      commit("sendLocalCartItemsSuccess", response.data);
    } catch (error) {
      commit("sendLocalCartItemsError", error);
    }
  },
  cartItems: async ({ commit }) => {
    try {
      const userData = getToken();
      if (userData) {
        commit("cartItemsRequest");
        const response = await cart.items();
        commit("cartItemsSuccess", response.data);
      } else {
        commit("cartItemsRequest");
        const response = await cart.itemsOffline()
        commit("cartItemsSuccess", { data: response });
      }

    } catch (error) {
      commit("cartItemsError", error);
      console.log("Error:", error);
    }
  },
  addCartItem: async ({ commit }, product) => {
    try {
      const userData = getToken();
      if (userData) {
        commit("addCartItemRequest");
        const response = await cart.add(product.id);        
        commit("addCartItemSuccess", response.data.data);

      } else {
        commit("addCartItemRequest");
        const response = await cart.addOffline(product);
        localStorage.setItem("cart", JSON.stringify(response));
        let cartItem = response.find(item => {
          return item.product.id == product.id
        });
        commit("addCartItemSuccess", cartItem);
      }

    } catch (error) {
      commit("addCartItemError");
      console.log("Error:", error);
    }
  },
  updateCartItemQuantity: async ({ commit }, payload) => {
    try {
      commit("addCartItemRequest");

      let cartItem;
      const userData = getToken();
      if (userData) {
        const response = await cart.updateQuantity(payload);
        cartItem = response.data.data
      } else {
        const cart = JSON.parse(localStorage.getItem("cart")) || []
        cartItem = cart.find((item) => item.product.id === payload.productId)
        cartItem.quantity = payload.payload.quantity;

        localStorage.setItem('cart', JSON.stringify(cart))
      }

      commit("addCartItemSuccess", cartItem)
    } catch (error) {
      commit("addCartItemError");
      window.e = error
    }
  },
  // decreases only the quantity of the item
  removeItem: async ({ commit }, payload) => {
    try {
      const userData = getToken();
      if (userData) {
        commit("removeItemRequest");
        // eslint-disable-next-line no-unused-vars
        const response = await cart.decrement(payload.product.id);
        commit("removeItemSuccess", payload.product.id);
        commit("removeCartItemShop", payload.product);
      } else {
        commit("removeItemRequest");
        const response = await cart.decrementOffline(payload.product.id);
        localStorage.setItem("cart", JSON.stringify(response));
        commit("removeItemSuccess", payload.product.id);
        commit("removeCartItemShop", payload.product);
      }

    } catch (error) {
      commit("removeItemError", error);
      console.log("Error:", error);
    }
  },
  // removes the whole item including all its quantities
  removeAllItems: async ({ commit }, product) => {
    try {
      const userData = getToken();
      if (userData) {
        commit("removeAllItemsRequest");
        // eslint-disable-next-line no-unused-vars
        const response = await cart.removeProduct(product.id);
        commit("removeAllItemsSuccess", product.id);
        commit("removeCartItemShop", product);

      } else {
        commit("removeAllItemsRequest");
        let response = await cart.removeProductOffline(product.id);
        localStorage.setItem("cart", JSON.stringify(response));
        commit("removeAllItemsSuccess", product.id);
        commit("removeCartItemShop", product);
      }

    } catch (error) {
      commit("removeAllItemsError", error);
      console.log("Error:", error);
    }
  },


  // reset
  reset: ({ commit }) => {
    commit('reset')
  }
};

const mutations = {
  // sending local cart items when user logs in
  sendLocalCartItemsRequest(state) {
    state.sendLocalCartItemsStatus = 1
  },
  sendLocalCartItemsSuccess(state, cart) {
    state.sendLocalCartItemsStatus = 2
    state.cart = cart.data
    state.sendLocalCartItemsMessage = "Local cart items successfully posted"
    localStorage.removeItem("cart");

  },
  sendLocalCartItemsError(state, error) {
    state.sendLocalCartItemsStatus = 3
    state.sendLocalCartItemsError = error
  },

  // getting cart items
  cartItemsRequest(state) {
    state.cartItemsStatus = 1
  },
  cartItemsSuccess(state, cart) {
    if (cart.data) {
      state.cart = cart.data
    } else {
      state.cart = []
    }
    state.cartQuantity = state.cart.reduce((acc, cartItem) => {
      return cartItem.quantity + acc;
    }, 0);
    state.cartItemsStatus = 2
    state.cartItemsMessage = "Cart Items Retrieved Successfully"
  },
  cartItemsError(state, error) {
    state.cartItemsStatus = 3
    state.cartItemsMessage = error
  },

  // adding cart item to cart
  addCartItemRequest(state) {
    state.addCartItemStatus = 1
  },
  addCartItemSuccess(state, cartItem) {
    let item = state.cart.find(itemTmp => itemTmp.product.id == cartItem.product.id);
    if (item) {
      // cartItem.quantity += 1
      item.quantity = cartItem.quantity
    } else {
      state.cart.unshift(cartItem);
    }

    state.cartQuantity = state.cart.reduce((acc, item) => {
      return item.quantity + acc;
    }, 0);
    state.addCartItemStatus = 2
    state.addCartItemMessage = "Item Added Successfully to cart"
  },
  addCartItemError(state, error) {
    state.addCartItemStatus = 3
    state.addCartItemMessage = error
  },

  // decreasing cart item quantity
  removeItemRequest(state) {
    state.removeItemStatus = 1
  },
  removeItemSuccess(state, productId) {
    let cartItem = state.cart.find(item => item.product.id == productId);
    if (cartItem) {
      if (cartItem.quantity > 1) {
        cartItem.quantity -= 1
      } else {
        let cartItemIndex = state.cart.findIndex(item => item.product.id == productId);
        state.cart.splice(cartItemIndex, 1);
      }
    }
    state.cartQuantity = state.cart.reduce((acc, cartItem) => {
      return cartItem.quantity + acc;
    }, 0);
    state.removeItemStatus = 2
    state.removeItemMessage = "Cart item removed successfully"
  },
  removeItemError(state, error) {
    state.removeItemStatus = 3
    state.removeItemMessage = error
  },

  // removing the whole item regardless of quantities
  removeAllItemsRequest(state) {
    state.removeAllItemsStatus = 1
  },
  removeAllItemsSuccess(state, productId) {
    let cartItemIndex = state.cart.findIndex(item => item.product.id == productId);
    state.cart.splice(cartItemIndex, 1);
    state.cartQuantity = state.cart.reduce((acc, cartItem) => {
      return cartItem.quantity + acc;
    }, 0);
    state.removeAllItemsStatus = 2
    state.removeAllItemsMessage = "Cart item successfully removed"
  },
  removeCartItemShop(state, product) {
    // cartItem shops currently in localStorage
    let cartItemShops = JSON.parse(localStorage.getItem("cartItemShops"));


    // other products from the same shop
    let otherProducts = state.cart.filter(cartItem => cartItem.product.shop_id === product.shop_id);

    if (otherProducts.length === 0) {
      // shop to remove
      let shopIndexToRemove = cartItemShops.findIndex(shop => shop.id === product.shop_id);
      cartItemShops.splice(shopIndexToRemove, 1);
    }

    // new cartItemShops saved to localStorage
    localStorage.setItem("cartItemShops", JSON.stringify(cartItemShops));

  },
  removeAllItemsError(state, error) {
    state.removeAllItemsStatus = 3
    state.removeAllItemsMessage = error
  },

  // Reset to initial state
  reset(state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}